/*
 * @Author: huboyi
 * @Date: 2022-03-21 10:43:04
 * @LastEditors: youyazhou 284964834@qq.com
 * @LastEditTime: 2025-06-09 10:13:36
 * @Description:
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui'
import Vue from 'vue'
import App from './App'
import promise from 'es6-promise'
import store from "@/store/store.js"
import Cookie from '@/utils/cookie.js'
import loading from "@/config/loading/loading.js"
import dataV from '@jiaminghi/data-view'
import PdfPreview from '@/components/PdfPreview/index.js'
import PdfPreviewSymbol from '@/components/PdfPreviewSymbol/index.js'

// import './utils/flexible'
// import rem from './utils/rem';
import router from './router'
// rem()
// import 'amfe-flexible';

Vue.prototype.$bus = new Vue();
Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
promise.polyfill()
    /* eslint-disable no-new */
Vue.prototype.$setCookie = Cookie.setCookie
Vue.prototype.$getCookie = Cookie.getCookie
Vue.prototype.$delCookie = Cookie.clearCookie
Vue.prototype.$getNestedCookie = Cookie.getNestedCookie
Vue.prototype.$updateNestedCookie = Cookie.updateNestedCookie
Vue.use(loading)
Vue.use(dataV);
Vue.use(PdfPreview)
Vue.use(PdfPreviewSymbol)
const app = new Vue({
        el: '#app',
        router,
        store,
        components: { App },
        template: '<App/>'
    })
    // app.$router.push({ name: "Index" })
window.vueApp = app


// WEBPACK FOOTER //
// ./src/main.js